import React from 'react';

import { DossierDtoAdminFonctionnel } from 'lib_api/lib/api/gen';

import ImporterPieceJointeBase from 'components/ImporterPieceJointe/ImporterPieceJointeBase/ImporterPieceJointeBase';
import { useApi } from 'hooks/ApiStoreContext';
import { useDossierAdminContext } from 'hooks/dossierAdmin/DossierAdminContext';

import 'components/UpdateDonneesVehicule/UpdateDonneesVehicule.less';

interface UpdateDonneesVehiculeProps {
  closeModal: () => void;
}

function ImporterPieceJointeAdminFonctionnel({
  closeModal,
}: UpdateDonneesVehiculeProps): React.ReactElement {
  const [{ result, setDossier: setDossierInContext }, { fetchEvents }] =
    useDossierAdminContext();
  const dossierId = result.id;
  const { AdminFonctionnelControllerApi: adminController } = useApi();

  async function setDossier(dossier: DossierDtoAdminFonctionnel) {
    setDossierInContext(dossier);
    await fetchEvents();
  }

  return (
    <ImporterPieceJointeBase
      closeModal={closeModal}
      dossierId={dossierId}
      setDossier={setDossier}
      controller={adminController}
    />
  );
}

export default ImporterPieceJointeAdminFonctionnel;
